import { getMethodUnexpectedArgsErrorMsg } from './errorMessages';
export function callToMessage(_ref) {
  var domain = _ref.domain,
      serviceName = _ref.serviceName,
      name = _ref.name,
      hasParams = _ref.hasParams,
      args = _ref.args;
  var expectedParamsNumber = hasParams ? 1 : 0;

  if (args.length !== expectedParamsNumber) {
    throw new Error(getMethodUnexpectedArgsErrorMsg(domain, serviceName, name));
  }

  return {
    name: name,
    domain: domain,
    serviceName: serviceName,
    payload: hasParams ? args[0] : {}
  };
}
//# sourceMappingURL=utils.js.map